import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Set_ModelCheckbox } from "../SliceStockTransfer";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";

import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import AutoGraphRoundedIcon from "@mui/icons-material/AutoGraphRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Tooltip } from "@mui/material";

export default function GCContent({
  sTransItemStockObj,
  xTransItemStockShow,
  vRdxWmsHead,
  // xKey,
  // xFocusInput,
  xBufferObj,
  sUnit,
  fUnit,
  fQty_Save_onKeyUp,
  fItemName,
  fOpenContentItemSearchModalKey,
  fQty,

  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
  xErrorMsgDetail,
  xContent_Focus,
  xContent_Blur,
  fNarration,
  setBufferObj,
  fModalPoType,
  fModalPoNo,
  ReqVsTransfer = () => {},
}) {
  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state.SliceStockTransfer.value.WmsStockTransferCheckbox
  );
  const vModelCheckboxArr = [
    // { name: "RefDoc", rdxName: vRdxCheckbox.RefDoc },
    { name: "ItemCode", rdxName: vRdxCheckbox.ItemCode },
    { name: "PackQty", rdxName: vRdxCheckbox.PackQty },
  ];
  const [sIsChecked, setIsChecked] = useState(false);
  const [sGrnCheckBox, setGrnCheckbox] = useState(vRdxCheckbox);
  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const fModalContentOpen = () => {
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };
  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setGrnCheckbox((values) => ({ ...values, [nameValue]: iSCheck }));
  };
  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    const updatedObj = Object.keys(vRdxCheckbox).reduce((acc, key) => {
      acc[key] = iSCheck;
      return acc;
    }, {});

    // Update the state with the new object
    setGrnCheckbox(updatedObj);
  };
  useEffect(() => {
    dispatch(Set_ModelCheckbox(sGrnCheckBox));
    const vIsAllTrue = Object.values(sGrnCheckBox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [sGrnCheckBox, dispatch]);
  return (
    <form className="Wms-inbound-grn-content" id="WmsStockTransferContent">
      <Grid
        container
        spacing={0.9}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid item xs={12} sm={12} md={3} textAlign={"center"}></Grid>
          <Grid item xs={9} sm={9} md={3}>
            <div className="d-flex justify-content-between">
              <span
                className={
                  vRdxWmsHead.A_DocStat === "POST"
                    ? "hide-all-time"
                    : "d-flex justify-content-between align-items-center"
                }
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Stock=" + sTransItemStockObj.RPStock}
                />{" "}
                &nbsp; &nbsp;
                {xTransItemStockShow >= 0 ? (
                  <>
                    {!xMediaQuery && (
                      <CmpTypographyField
                        xcomponent={"span"}
                        xText={" CostPr=" + sTransItemStockObj.CostPr}
                      />
                    )}
                    &nbsp;&nbsp;
                     {!xMediaQuery && (
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"LPRate=" + sTransItemStockObj.LPRate}
                    />
                     )}
                  </>
                  
                ) : (
                  <></>
                )}
                &nbsp; &nbsp;
              </span>
            </div>
          </Grid>
          {!xMediaQuery && (
            <Grid item xs={3} sm={3} md={3}>
              <MoreHorizOutlinedIcon
                onClick={(e) => {
                  fModalContentOpen(e, "checkboxModal");
                }}
                className="form-label gnr-title-txt"
              />
            </Grid>
          )}
        </Grid>
        {/* { !xMediaQuery &&   <Grid item xs={6} sm={3} md={1} className="lastkeyDetect">
          
          <CmpTextFieldV1
            xLabelText="S.No"
            xSize="small"
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
            // xOnKeyUp={xKey}
          />
        </Grid>} */}
        {/* <Grid item xs={6} sm={3} md={2}   className={vRdxCheckbox.RefDoc ? "lastkeyDetect " : "hide-content"}    >
          <GCToggleSearchV1
            xtabIndex={"101"}
            xLabelText={"Ref.Document"}
            xName={"B_RefDocTypName"}
            xType={"text"}
            xValue={xBufferObj?.B_RefDocTypName}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                B_RefDocTyp: "",
                B_RefDocTypName: e.target.value,
              }))
            }}
            xOnKeyUp={fModalPoType}
            xonClickbtn={fModalPoType}
            xError={false}
            xErrorMessage={""}
          />
        </Grid> */}
        {/* <Grid item xs={6} sm={4} md={2}   className={vRdxCheckbox.RefDoc ? "lastkeyDetect " : "hide-content"}
        >
       
          <GCToggleSearchV1
           xLabelText="RefDocNo"
            xtabIndex={"101"}
            xName={"B_RefDocNo"}
            xType={"text"}
            xValue={xBufferObj?.B_RefDocNo}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                B_RefDocNo: e.target.value,
              }))
            }}
            xOnKeyUp={fModalPoNo}
            xonClickbtn={fModalPoNo}
            xError={false}
            xErrorMessage={""}
          />
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          className={vRdxCheckbox.ItemCode ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Item Code"
            xSize="small"
            xtabIndex={"101"}
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={10}
          // md={"auto"}
          // lg={"auto"}
          md={xToggle ? 5 : 4}
          className="lastkeyDetect"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"102"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xSize="small"
            xtabIndex={"103"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xOnKeyUp={(e) => fQty_Save_onKeyUp(e)}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={2} className="lastkeyDetect">
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"104"}
            xLabelText="Unit"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
            xonBlur={xContent_Blur}
          />
        </Grid>

        {vRdxCheckbox.PackQty && (
          <Grid item xs={4} sm={1} md={1} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="PackQty"
              xSize="small"
              xtabIndex={"103"}
              xValue={xBufferObj.B_PackQty}
              xType={"text"} // text/number/password
              xName={"B_PackQty"}
              xReadOnly={false}
              xOnChange={() => {}}
              xError={false}
              xErrorMessage={""}
            />
          </Grid>
        )}
        <Grid item xs={4} sm={2} md={2} className="lastkeyDetect">
          {/* <CmpTypographyField xcomponent={"div"} xText={"Narration"} /> */}
          {/* <CmpSelectField
            xtabIndex={"104"}
            xLabelText="Narration"
            xValue={xBufferObj.Narration}
            xOnChange={fNarration}
            xName={"Narration"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.Narration === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.Narration}
            xDisable={false}
            xonBlur={xContent_Blur}
          /> */}
          <CmpTextFieldV1
            xLabelText="Narration"
            xSize="small"
            xtabIndex={"103"}
            xValue={xBufferObj.Narration}
            xType={"text"} // text/number/password
            xName={"Narration"}
            xReadOnly={false}
            xOnChange={fNarration}
            xError={xErrorMsgDetail.Narration === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.Narration}
            // xonFocus={(e) => {
            //   xContent_Focus(e);
            // }}
            // xOnKeyUp={(e) => fQty_Save_onKeyUp(e)}
            // xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.5}
          className="lastkeyDetect"
          display={"flex  "}
          alignItems={"center"}
          justifyContent={"space-around"}
        >
          <div>
            <Tooltip title="Req vs Transfer" arrow>
              <CmpButtonKWithIcon
                xOnClick={ReqVsTransfer}
                xDisabled={false}
                xIcon={<AutoGraphRoundedIcon fontSize={"small"} />}
                xcolor="primary"
              />
            </Tooltip>
          </div>

          <div>
            {xMediaQuery && (
              <CmpButtonKWithIcon
                xOnClick={(e) => {
                  console.log(xMediaQuery);

                  fModalContentOpen(e, "checkboxModal");
                }}
                xDisabled={false}
                xIcon={<VisibilityIcon fontSize={"small"} />}
                xcolor="primary"
              />
            )}
          </div>
        </Grid>
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-content-checkbox">
          <GCTitleSticky title={"Detail list"} onClose={fModalContentClose} />

          <div className="container-fluid">
            <div className="wms-label">
              <div className="checkbox-mb">
                <label className="form-label ">
                  <input
                    className="form-check-input "
                    type="checkbox"
                    name="AllChecked"
                    checked={sIsChecked}
                    onChange={(e) => {
                      fIsAllChecked(e);
                    }}
                  />{" "}
                  All
                </label>
              </div>
              <>
                {vModelCheckboxArr?.map((obj, index) => (
                  <div className="checkbox-mb" key={"Wmscheckbox" + index}>
                    <label className="form-label">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        name={obj.name}
                        checked={obj.rdxName}
                        onChange={(e) => {
                          fSetCheckBox(e);
                        }}
                      />{" "}
                      {obj.name}
                    </label>
                  </div>
                ))}
              </>
            </div>
          </div>
        </Box>
      </Modal>
    </form>
  );
}
